import { ReactNode } from 'react';

import {
  WorksheetCardTitle,
  WorksheetCardWrapper,
} from '../worksheet-card.style';
import {
  InputStyled,
  CheckboxWorksheetCardStyled,
  CheckboxWorksheetCardCheckMark,
  CheckboxWorksheetCardOverlay,
  CheckboxWorksheetCardLabel,
  CheckboxWorksheetBadge,
} from './checkbox-worksheet-card.style';
import IconCircleCheck from 'approot/shared/icons/icon-circle-check';

type Props = {
  checked: boolean;
  content?: ReactNode;
  contentBadge?: ReactNode;
  title: ReactNode;
  ratio?: number;
  fieldName: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
};

const CheckableCard = ({
  title,
  content,
  contentBadge,
  ratio = 100,
  fieldName,
  id,
  value,
  checked,
  onChange,
}: Props) => {
  return (
    <WorksheetCardWrapper>
      <CheckboxWorksheetCardLabel htmlFor={id}>
        <InputStyled
          type="checkbox"
          id={id}
          data-testid={id}
          value={value}
          name={fieldName}
          checked={checked}
          onChange={() => onChange(value)}
        />
        <CheckboxWorksheetCardStyled $ratio={ratio}>
          {content}
          {contentBadge && (
            <CheckboxWorksheetBadge>{contentBadge}</CheckboxWorksheetBadge>
          )}

          <CheckboxWorksheetCardOverlay />
          <CheckboxWorksheetCardCheckMark>
            <IconCircleCheck width={40} height={40} />
          </CheckboxWorksheetCardCheckMark>
        </CheckboxWorksheetCardStyled>

        {title && <WorksheetCardTitle>{title}</WorksheetCardTitle>}
      </CheckboxWorksheetCardLabel>
    </WorksheetCardWrapper>
  );
};

export default CheckableCard;
